export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const RESET_PASSWORD = "/resetPassword";
export const FEEDBACK = "/feedback";
export const RESOURCES = "/resources";
export const DEPLOYMENT_ID = "/deployment/:deploymentId";
export const DEPLOYMENT_USER = `/deployment/:deploymentId/user/:deploymentAccountId`;
